// Blog Content CLS Fix - Desktop Only
(function() {
  'use strict';
  
  // Only run on desktop
  if (window.innerWidth < 768) return;
  
  // Function to add dimensions to content images
  function fixContentImages() {
    const contentImages = document.querySelectorAll('.blog-content img, .single-blog-area .blog-content img');
    
    contentImages.forEach(img => {
      // Skip if already processed
      if (img.dataset.clsFixed) return;
      
      // Add loading placeholder
      img.style.backgroundColor = '#f8f8f8';
      img.style.minHeight = '100px';
      
      // Handle different image types
      if (img.style.float === 'left' || img.style.cssText.includes('float: left')) {
        img.style.maxWidth = '50%';
        img.style.marginRight = '15px';
        img.style.marginBottom = '10px';
      } else if (img.style.float === 'right' || img.style.cssText.includes('float: right')) {
        img.style.maxWidth = '50%';
        img.style.marginLeft = '15px';
        img.style.marginBottom = '10px';
      } else if (img.style.textAlign === 'center' || img.style.cssText.includes('text-align: center')) {
        img.style.display = 'block';
        img.style.marginLeft = 'auto';
        img.style.marginRight = 'auto';
        img.style.float = 'none';
      } else {
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
        img.style.display = 'block';
        img.style.margin = '15px 0';
      }
      
      // Mark as processed
      img.dataset.clsFixed = 'true';
      
      // Remove placeholder when image loads
      img.addEventListener('load', function() {
        this.style.backgroundColor = '';
        this.style.minHeight = '';
      });
      
      // Handle already loaded images
      if (img.complete) {
        img.style.backgroundColor = '';
        img.style.minHeight = '';
      }
    });
  }
  
  // Function to handle new content (for dynamic loading)
  function observeContentChanges() {
    const contentContainers = document.querySelectorAll('.blog-content, .single-blog-area .blog-content');
    
    contentContainers.forEach(container => {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) { // Element node
                if (node.tagName === 'IMG') {
                  fixContentImages();
                } else if (node.querySelectorAll) {
                  const images = node.querySelectorAll('img');
                  if (images.length > 0) {
                    fixContentImages();
                  }
                }
              }
            });
          }
        });
      });
      
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });
  }
  
  // Function to preload critical content images
  function preloadCriticalContentImages() {
    const contentImages = document.querySelectorAll('.blog-content img, .single-blog-area .blog-content img');
    const firstImage = contentImages[0];
    
    if (firstImage && firstImage.src) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = firstImage.src;
      document.head.appendChild(link);
    }
  }
  
  // Initialize when DOM is ready
  function init() {
    fixContentImages();
    observeContentChanges();
    preloadCriticalContentImages();
  }
  
  // Run initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (window.innerWidth >= 768) {
        fixContentImages();
      }
    }, 250);
  });
  
})();
